import React from 'react';
import Map from 'components/reports/map';

export default function VotersMap() {
  return <Map />;
}
